/* eslint-disable react/jsx-no-bind */
import React from 'react';
import { useDispatch } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import Icon from '../../../base/icons/components/Icon';
import { IconCloseLarge } from '../../../base/icons/svg';
import Button from '../../../base/ui/components/web/Button';
import { BUTTON_TYPES } from '../../../base/ui/constants.web';
import { editPoll, removePoll } from '../../actions';
import { isSubmitAnswerDisabled } from '../../functions';
import AbstractPollAnswer from '../AbstractPollAnswer';
const useStyles = makeStyles()(theme => {
    return {
        container: {
            margin: '16px',
            padding: '20px',
            backgroundColor: theme.palette.ui02,
            borderRadius: '12px',
            wordBreak: 'break-word',
            border: `1px solid rgba(255, 255, 255, 0.06)`,
            transition: 'box-shadow 0.2s ease',
            '&:hover': {
                boxShadow: '0 2px 12px rgba(0, 0, 0, 0.15)'
            }
        },
        closeBtn: {
            cursor: 'pointer',
            float: 'right'
        },
        header: {
            marginBottom: '24px'
        },
        previewBadge: {
            display: 'inline-block',
            backgroundColor: theme.palette.warning01,
            color: '#000',
            padding: '2px 10px',
            borderRadius: '12px',
            fontSize: '0.75rem',
            fontWeight: 600,
            marginBottom: '8px'
        },
        question: {
            ...theme.typography.heading6,
            color: theme.palette.text01,
            marginBottom: '8px'
        },
        creator: {
            ...theme.typography.bodyShortRegular,
            color: theme.palette.text02
        },
        answerList: {
            listStyleType: 'none',
            margin: 0,
            padding: 0,
            marginBottom: '24px'
        },
        answer: {
            display: 'flex',
            marginBottom: '16px'
        },
        radioLabel: {
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            cursor: 'pointer',
            color: theme.palette.text01,
            ...theme.typography.bodyShortRegular,
            '& input[type="radio"]': {
                appearance: 'none',
                width: '20px',
                height: '20px',
                border: `2px solid ${theme.palette.text03}`,
                borderRadius: '50%',
                outline: 'none',
                cursor: 'pointer',
                position: 'relative',
                flexShrink: 0,
                transition: 'border-color 0.2s ease',
                '&:checked': {
                    borderColor: theme.palette.action01,
                    '&::after': {
                        content: '""',
                        position: 'absolute',
                        top: '3px',
                        left: '3px',
                        width: '10px',
                        height: '10px',
                        borderRadius: '50%',
                        backgroundColor: theme.palette.action01
                    }
                },
                '&:disabled': {
                    opacity: 0.5,
                    cursor: 'default'
                }
            }
        },
        footer: {
            display: 'flex',
            justifyContent: 'flex-end'
        },
        buttonMargin: {
            marginRight: theme.spacing(3)
        }
    };
});
const PollAnswer = ({ creatorName, checkBoxStates, poll, selectSingleAnswer, setCheckbox, setCreateMode, skipAnswer, skipChangeVote, sendPoll, submitAnswer, t }) => {
    const { changingVote, saved: pollSaved } = poll;
    const dispatch = useDispatch();
    const { classes } = useStyles();
    return (React.createElement("div", { className: classes.container, id: `poll-${poll.pollId}` },
        pollSaved && React.createElement(Icon, { ariaLabel: t('polls.closeButton'), className: classes.closeBtn, onClick: () => dispatch(removePoll(poll)), role: 'button', src: IconCloseLarge, tabIndex: 0 }),
        React.createElement("div", { className: classes.header },
            pollSaved && (React.createElement("div", { className: classes.previewBadge }, t('polls.preview'))),
            React.createElement("div", { className: classes.question }, poll.question),
            React.createElement("div", { className: classes.creator }, t('polls.by', { name: creatorName }))),
        React.createElement("ul", { className: classes.answerList }, poll.answers.map((answer, index) => (React.createElement("li", { className: classes.answer, key: index },
            React.createElement("label", { className: classes.radioLabel, htmlFor: `poll-answer-radio-${poll.pollId}-${index}` },
                React.createElement("input", { checked: checkBoxStates[index], disabled: poll.saved, id: `poll-answer-radio-${poll.pollId}-${index}`, name: `poll-${poll.pollId}`, onChange: () => selectSingleAnswer(index), type: "radio" }),
                React.createElement("span", null, answer.name)))))),
        React.createElement("div", { className: classes.footer }, pollSaved ? React.createElement(React.Fragment, null,
            React.createElement(Button, { accessibilityLabel: t('polls.answer.edit'), className: classes.buttonMargin, labelKey: 'polls.answer.edit', onClick: () => {
                    setCreateMode(true);
                    dispatch(editPoll(poll.pollId, true));
                }, type: BUTTON_TYPES.SECONDARY }),
            React.createElement(Button, { accessibilityLabel: t('polls.answer.sendFinal'), labelKey: 'polls.answer.sendFinal', onClick: sendPoll })) : React.createElement(React.Fragment, null,
            React.createElement(Button, { accessibilityLabel: t('polls.answer.skip'), className: classes.buttonMargin, labelKey: 'polls.answer.skip', onClick: changingVote ? skipChangeVote : skipAnswer, type: BUTTON_TYPES.SECONDARY }),
            React.createElement(Button, { accessibilityLabel: t('polls.answer.submit'), disabled: isSubmitAnswerDisabled(checkBoxStates), labelKey: 'polls.answer.submit', onClick: submitAnswer })))));
};
/*
 * We apply AbstractPollAnswer to fill in the AbstractProps common
 * to both the web and native implementations.
 */
// eslint-disable-next-line new-cap
export default AbstractPollAnswer(PollAnswer);
